export default __webpack_public_path__ + "static/media/mc_img_01.67ce21c8.png";